import { SlickSliderOptions } from "./slick-slider-options.model";

export class SlickSliderComponent {

    private _window: JQuery<Window> = null;
    private _currentContext: JQuery = null;

    private _sliderSelector: string = null;
    private _sliderContext: JQuery = null;
    private _sliderOptions: JQuerySlickOptions = null;

    private _navigationSelector: string = null;
    private _navigationContext: JQuery = null;
    private _navigationOptions: JQuerySlickOptions = null;

    private get isSliderInitialized(): boolean {
        return this._sliderContext.hasClass("slick-initialized");
    }

    private bindEvents(): void {
        this._window.on("orientationchange resize", () => {
            if (this.isSliderInitialized) {
                this._sliderContext.slick("resize");
                this._navigationContext?.slick("resize");
            } else {
                this.initSlider();
            }
        });
    }

    private initSlider(): void {
        this._sliderContext.slick(this._sliderOptions);
        this._navigationContext?.slick(this._navigationOptions);
    }

    private parseContext(): void {
        this._window = $(window);
        this._sliderContext = $(this._sliderSelector, this._currentContext);
        if (this._navigationSelector) {
            this._navigationContext = $(this._navigationSelector, this._currentContext);
        }
    }

    public init(options: SlickSliderOptions): void {
        this._currentContext = options.context || this._currentContext;

        this._sliderOptions = options.sliderOptions || this._sliderOptions;
        this._sliderSelector = options.sliderSelector || this._sliderSelector;

        this._navigationOptions = options.navigationOptions || this._navigationOptions;
        this._navigationSelector = options.navigationSelector || this._navigationSelector;

        this.parseContext();
        this.initSlider();
        this.bindEvents();
    }

    public static init(options: SlickSliderOptions): SlickSliderComponent {
        const component = new SlickSliderComponent();
        component.init(options);
        return component;
    }
}
